import { StudioHotspotImageV2 } from 'shared/studio/StudioHotspotImage';
import { Typography } from '@ag1/ui';
import { CustomPortableText } from 'shared/studio/PortableText';
import { UnifiedButton, UnifiedButtonType } from 'shared/studio/UnifiedButton';
import { FullEduHubArticleResult } from 'types/studio/eduHub';
import styles from './EduArticleImageAndText.module.scss';

interface Props {
  content: FullEduHubArticleResult['eduArticleCommonData']['eduImageAndText'];
}

export const EduArticleImageAndText = ({ content }: Props) => {
  if (!content?.heading || !content?.image) {
    return null;
  }

  return (
    <section className={styles.root}>
      <div className={styles.content}>
        <Typography
          variant="headlineSans"
          size="2"
          noPadding
          color="black-new"
          className={styles.mobileHeading}>
          <CustomPortableText value={content.heading} />
        </Typography>
        <StudioHotspotImageV2 className={styles.image} image={content.image} />
        <div className={styles.textBlock}>
          <Typography
            variant="headlineSans"
            size="2"
            noPadding
            color="black-new"
            className={styles.desktopHeading}>
            <CustomPortableText value={content.heading} />
          </Typography>
          <UnifiedButton
            unifiedButton={content.unifiedButton as UnifiedButtonType}
            sectionType="edu-hub-article"
            className={styles.button}
            size="medium"
            theme="new"
          />
        </div>
      </div>
    </section>
  );
};
